import { DocumentStatus } from "@daytrip/legacy-enums";
import { Exclude, Expose } from "class-transformer";
import { IsArray, IsDate, IsDefined, IsString, IsUUID, MaxLength } from "class-validator";
import { v4 as uuid } from "uuid";

import { statusGetter } from "../statusGetter";
import { TransformToDate } from "../transformers/transformToDate";

@Exclude()
export class Document {
    @IsUUID("4")
    @IsDefined()
    @Expose()
    public _id: string = uuid();

    @IsDate()
    @Expose()
    @TransformToDate
    public createdAt: Date = new Date();

    @IsUUID("4")
    @IsDefined()
    @Expose()
    public documentTypeId: string;

    @IsArray()
    @IsDefined()
    @Expose()
    public fileIds: string[] = [];

    @MaxLength(512)
    @IsString()
    @Expose()
    public description?: string;

    @IsDate()
    @Expose()
    @TransformToDate
    public acceptedAt?: Date;

    @IsDate()
    @Expose()
    @TransformToDate
    public declinedAt?: Date;

    @IsDate()
    @Expose()
    @TransformToDate
    public outdatedAt?: Date;

    @IsDate()
    @Expose()
    @TransformToDate
    public deletedAt?: Date;

    @IsString()
    @Expose()
    public declinationReason?: string;

    @IsString()
    @Expose()
    public managementNote?: string;

    @Expose()
    public externalDocumentId?: string;

    @Expose()
    public kycStatus: DocumentStatus;

    public getStatus(): DocumentStatus {
        if (this.kycStatus) {
            return this.kycStatus;
        }

        const virtualStatus = statusGetter(this, Document, DocumentStatus);
        return virtualStatus;
    }

    public static statusPrototype(status: DocumentStatus): Document {
        const defined = new Date();

        switch (status) {
            case DocumentStatus.OUT_OF_DATE:
                return {
                    outdatedAt: defined,
                } as Document;

            case DocumentStatus.REFUSED:
                return {
                    declinedAt: defined,
                } as Document;

            case DocumentStatus.VALIDATED:
                return {
                    acceptedAt: defined,
                    declinedAt: undefined,
                } as Document;

            case DocumentStatus.VALIDATION_ASKED:
            default:
                return {
                    declinedAt: undefined,
                    acceptedAt: undefined,
                } as Document;
        }
    }
}
